import { useEffect, useState } from "react"

import { SettingsService } from "@/services/settings-service"

export function useInitSettings() {
  const [isSettingsInitialized, setIsSettingsInitialized] = useState(() =>
    SettingsService.isInitialized()
  )

  useEffect(() => {
    const handleInitialized = () => {
      setIsSettingsInitialized(true)
    }

    SettingsService.initializedEvent.on("initialized", handleInitialized)

    // The one-shot event may have fired between render and this effect, so
    // re-check after subscribing rather than waiting for an event that is gone.
    if (SettingsService.isInitialized()) {
      handleInitialized()
    }

    // Cleanup event listener on unmount
    return () => {
      SettingsService.initializedEvent.off("initialized", handleInitialized)
    }
  }, [])

  return { isSettingsInitialized }
}
